import { render, staticRenderFns } from "./WoundOverview.vue?vue&type=template&id=745ddb19"
import script from "./WoundOverview.vue?vue&type=script&lang=ts"
export * from "./WoundOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports